import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from 'redux-logger';
import { createReduxHistoryContext } from "redux-first-history";

import { createBrowserHistory } from "history";

import authReducer from './auth/authSlice';

const {
  createReduxHistory,
  routerMiddleware,
  routerReducer
} = createReduxHistoryContext({ history: createBrowserHistory() });

const middlewares = [routerMiddleware]

if (process.env.NODE_ENV === 'development') {
  const logger = createLogger({ collapsed: true, diff: true });
  middlewares.push(logger);
}

export const store = configureStore({
  reducer: combineReducers({
    router: routerReducer,
    auth: authReducer,
  }),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
});

export const history = createReduxHistory(store);